import { createRouter, createWebHistory } from "vue-router";
import Nav from "@/components/Nav.vue";

import HomeView from "@/views/HomeView.vue";
import AboutView from "@/views/AboutView.vue";
import DeporteSeleccionView from "@/views/DeporteSeleccionView.vue";
import ReservasView from "@/views/ReservasView.vue";

// --- Auth guard ---
import store from "@/store";
import CanchasConfiguracionView from "@/views/CanchasConfiguracionView.vue";
import AbonosView from "@/views/AbonosView.vue";
import ClientesView from "@/views/ClientesView.vue";
import UsuariosView from "@/views/UsuariosView.vue";

const hijos = [
  {
    path: "asd",
    name: "asd",
    display: "un hijo",
    icon: "notification_add",
    nav: true,
  },
  {
    path: "asd2",
    name: "asd2",
    display: "segundo hijo",
    icon: "notification_add",
    nav: true,
  },
];

export const appRoutes = [
  {
    path: "deportes",
    name: "deportes",
    display: "Deportes",
    icon: "score",
    nav: true,
    nivel_rol: 3,
    meta: { requiresAuth: true },
    component: DeporteSeleccionView,
  },
  {
    path: "reservas/:slug([a-z0-9-]+)?",
    name: "reservas",
    display: "Reservas",
    icon: "schedule",
    nav: true,
    nivel_rol: 3,
    meta: { requiresAuth: true },
    component: ReservasView,
  },
  {
    path: "abonos",
    name: "abonos",
    display: "Abonos",
    icon: "save_clock",
    nav: true,
    nivel_rol: 3,
    meta: { requiresAuth: true },
    component: AbonosView,
  },
  {
    path: "clientes",
    name: "clientes",
    display: "Clientes",
    icon: "group",
    nav: true,
    nivel_rol: 3,
    meta: { requiresAuth: true },
    component: ClientesView,
  },
  {
    path: "estadisticas",
    name: "estadisticas",
    display: "Estadísticas",
    icon: "analytics",
    nav: true,
    nivel_rol: 2,
    component: () => import("@/views/EstadisticasView.vue"),
  },
  {
    path: "configuraciones",
    name: "configuraciones",
    display: "Configuraciones",
    icon: "brightness_7",
    nav: true,
    nivel_rol: 2,
    component: () => import("@/views/ParametrosGeneralesView.vue"),
  },
  {
    path: "dias-horarios",
    name: "dias-horarios",
    display: "Días / Horarios",
    icon: "calendar_clock",
    nav: true,
    nivel_rol: 2,
    component: () => import("@/views/DiasHorariosConfigView.vue"),
  },
  {
    path: "formas-pago",
    name: "formas-pago",
    display: "Formas de Pago",
    icon: "request_quote",
    nav: true,
    nivel_rol: 2,
    component: () => import("@/views/FormasPagoConfigView.vue"),
  },
  {
    path: "mensajes-whatsapp",
    name: "mensajes-whatsapp",
    display: "Mensajes WhatsApp",
    icon: "whatsapp",
    nav: true,
    nivel_rol: 2,
    meta: { requiresAuth: true },
    component: () => import("@/views/MensajesWhatsAppView.vue"),
  },
  {
    path: "usuarios",
    name: "usuarios",
    display: "Usuarios",
    icon: "manage_accounts",
    nav: true,
    nivel_rol: 2,
    meta: { requiresAuth: true },
    component: () => import("@/views/UsuariosView.vue"),
  },
  {
    path: "mejoras",
    name: "mejoras",
    display: "Mejoras",
    icon: "stars",
    nav: true,
    nivel_rol: 2,
    component: () => import("@/views/MejorasVersiones.vue"),
  },
  {
    path: "about2",
    name: "padre",
    display: "About",
    icon: "info",
    nav: false,
    nivel_rol: 3,
    children: hijos,
    component: AboutView,
  },
  {
    path: "/mi-perfil",
    name: "Mi Perfil",
    nav: false,
    nivel_rol: 3,
    meta: { requiresAuth: true },
    component: () => import("@/views/MiPerfilView.vue"),
  },
  {
    path: "/cambiar-password",
    name: "CambiarPassword",
    meta: { requiresAuth: true },
    nav: false,
    component: () => import("@/views/CambiarPasswordView.vue"),
  },
  {
    path: "nonav",
    name: "nonav",
    display: "nonav",
    icon: "alert",
    nav: false,
    nivel_rol: 3,
    component: AboutView,
  },
];

export const routes = [
  {
    path: "/",
    name: "home",
    meta: { public: true },
    component: HomeView,
  },
  {
    path: "/",
    component: Nav,
    children: appRoutes,
    meta: { requiresAuth: true },
  },
  {
    path: "/forgot-password",
    name: "ForgotPassword",
    meta: { public: true },
    component: () => import("@/views/OlvidePasswordView.vue"),
  },
  {
    path: "/reset-password",
    name: "ResetPassword",
    meta: { public: true },
    component: () => import("@/views/ReestablecerPasswordView.vue"),
  },
  // ✅ siempre al final
  {
    path: "/:pathMatch(.*)*",
    name: "not-found",
    meta: { public: true },
    component: () => import("@/views/NotFoundView.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some((r) => r.meta?.requiresAuth);
  const authed = store.getters["auth/isAuthenticated"];

  if (requiresAuth && !authed) {
    try {
      sessionStorage.setItem("ac_redirect_to", to.fullPath);
    } catch {}
    return next({ path: "/" });
  }

  if (to.path === "/" && authed) {
    const redirectTo = sessionStorage.getItem("ac_redirect_to") || "/deportes";
    try {
      sessionStorage.removeItem("ac_redirect_to");
    } catch {}
    if (to.fullPath !== redirectTo) return next(redirectTo);
  }

  next();
});

export default router;
